import React from 'react'
import { observer } from 'mobx-react-lite'
import { subDays, startOfToday, endOfToday } from 'date-fns'

import {
  ANALYTICS_EVENTS,
  Drawer,
  useEvent,
  useGlobalCopyStore,
  useTransactionStore,
} from '../../../../common'
import { TransactionDetails, TransactionList } from '../../../../transactions'
import { useAccountUiStore } from '../../../hooks/useUiStore'

const TransactionsTab = () => {
  const [guid, setGuid] = React.useState('')

  const { onEvent } = useEvent()
  const { selectedAccount } = useAccountUiStore()
  const { accounts: accountsCopy } = useGlobalCopyStore()
  const { isTransactionDataLoaded, loadTransactionData, setFilter, sortedTransactions } =
    useTransactionStore()

  React.useEffect(() => {
    if (!isTransactionDataLoaded) {
      loadTransactionData().finally()
    }
  }, [])

  const transaction = React.useMemo(
    () => sortedTransactions.find((t) => t.guid === guid),
    [guid, sortedTransactions],
  )

  React.useEffect(() => {
    setFilter({
      dateRange: { start: subDays(startOfToday(), 90), end: endOfToday() },
      accounts: [selectedAccount.guid],
    })
  }, [selectedAccount])

  React.useEffect(() => onEvent(ANALYTICS_EVENTS.ACCOUNT_DETAILS_VIEW_TRANSACTIONS), [])

  return (
    <>
      <TransactionList onClick={setGuid} />
      {transaction && (
        <Drawer
          ariaLabelClose={accountsCopy.close_drawer}
          isOpen={!!guid}
          onClose={() => setGuid('')}
          title={accountsCopy.transaction_drawer_title}
        >
          <TransactionDetails transaction={transaction} />
        </Drawer>
      )}
    </>
  )
}

export default observer(TransactionsTab)
